import { FC } from "react";

import { CoverageStatusEnumType } from "@libs/api/patients";
import CoverageStatusChecking from "@/assets/icons/coverage-checking.svg";
import CoverageStatusCovered from "@/assets/icons/coverage-covered.svg";
import CoverageStatusNotCovered from "@/assets/icons/coverage-not-covered.svg";
import CoverageStatusUnknown from "@/assets/icons/coverage-unknown.svg";

export const CoverageStatusIcon: FC<{
  coverageStatus: CoverageStatusEnumType;
}> = ({ coverageStatus }) => {
  const className = "w-5 h-5";
  switch (coverageStatus) {
    case "COVERED":
      return <CoverageStatusCovered className={className} />;
    case "NOT_COVERED":
      return <CoverageStatusNotCovered className={className} />;
    case "CHECKING":
      return <CoverageStatusChecking className={className} />;
    case "UNKNOWN":
      return <CoverageStatusUnknown className={className} />;
    default:
      return <CoverageStatusUnknown className={className} />;
  }
};
